/*
 * attachment-details.ts — attachment details management.
 */


export interface attachmentDetails {
    id: string;
    docType?: string;
    comment?: string;
    // Sent as ord_linkedDocuments_v2's allowSynchToPortal on upload -- see linkOrderDocument
    // in bc-api.ts. Defaults to false; per-file, toggled via the "Portal" radio in
    // attachments.ts.
    allowSynchToPortal?: boolean;
}

const allFilesDetails = new Map<string, attachmentDetails>();

// ─── Helpers ────────────────────────────────

export function getAttachmentDetails(id: string): attachmentDetails | undefined {
    return allFilesDetails.get(id);
}

export function getOrCreateAttachmentDetails(id: string): attachmentDetails {

    let attachment = allFilesDetails.get(id);

    if (!attachment) {
        attachment = {
            id,
            docType: "",
            comment: "",
            allowSynchToPortal: false
        };

        allFilesDetails.set(id, attachment);
    }

    return attachment;
}

export function setDocType(id: string, docType: string): void {
    getOrCreateAttachmentDetails(id).docType = docType;
}

export function setComment(id: string, comment: string): void {
    getOrCreateAttachmentDetails(id).comment = comment;
}

export function setAllowSynchToPortal(id: string, allowSynchToPortal: boolean): void {
    getOrCreateAttachmentDetails(id).allowSynchToPortal = allowSynchToPortal;
}